import { Box, Flex, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import SkeletonComponent from 'UiKit/skeleton';
import { Condition, Iteration } from 'Component/others';
import generateArray from 'Helper/generateArray';

import styles from './styles.module.css';

const ScheduleSkeleton = () => {
  const arrayList = generateArray(24);

  return (
    <Box padding="32px 24px" className={styles['schedule-skeleton__container']}>
      <Flex className={styles['section__head']}>
        <SkeletonComponent height="40px" width="106px" />
        <Flex gap="8px">
          <SkeletonComponent height="40px" width="104px" />
          <SkeletonComponent height="40px" width="104px" />
          <SkeletonComponent height="40px" width="157px" />
        </Flex>
      </Flex>

      <Box className={styles['section__filter']}>
        <Flex gap="16px" alignItems="center" mb="20px">
          <Flex gap="8px">
            <SkeletonComponent height="24px" width="24px" />
            <SkeletonComponent height="24px" width="24px" />
            <SkeletonComponent height="24px" width="184px" />
          </Flex>

          <SkeletonComponent height="40px" width="120px" />
          <SkeletonComponent height="40px" width="120px" />
        </Flex>

        <Flex gap="16px" flexWrap="wrap">
          <SkeletonComponent height="40px" width="168px" />
          <SkeletonComponent height="40px" width="168px" />
          <SkeletonComponent height="40px" width="168px" />
          <SkeletonComponent height="40px" width="168px" />
          <SkeletonComponent height="40px" width="168px" />
          <SkeletonComponent height="40px" width="168px" />
        </Flex>
      </Box>

      <Box className={styles['section__calendar']}>
        <Table className={styles['calendar']}>
          <Thead>
            <Tr>
              <Th>
                <Flex className={styles['skeleton__head']}>
                  <SkeletonComponent height="18px" width="24px" />
                </Flex>
              </Th>
              <Th>
                <Flex className={styles['skeleton__head']}>
                  <SkeletonComponent height="21px" width="24px" mb="2px" />
                </Flex>
              </Th>
              <Th>
                <Flex className={styles['skeleton__head']}>
                  <SkeletonComponent height="21px" width="24px" mb="2px" />
                </Flex>
              </Th>
              <Th>
                <Flex className={styles['skeleton__head']}>
                  <SkeletonComponent height="21px" width="24px" mb="2px" />
                </Flex>
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            <Iteration
              items={arrayList}
              render={(num) => {
                const isOdd = num % 2 === 0;

                return (
                  <Tr key={num}>
                    <Td>
                      <Condition statement={isOdd}>
                        <Flex className={styles['skeleton__column']}>
                          <SkeletonComponent height="16px" width="36px" />
                        </Flex>
                      </Condition>
                    </Td>
                    <Td></Td>
                    <Td></Td>
                    <Td></Td>
                  </Tr>
                );
              }}
            />
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
};

export default ScheduleSkeleton;
